import { CAP_SPACE_64 } from '@capillarytech/cap-ui-library/styled/variables';
import styled, { css } from 'styled-components';

export default css`
  .skeleton-loading { 
    margin-top: ${CAP_SPACE_64};
    margin-left: 15.71rem;
    margin-right: 15.71rem;
   }
`;

export const FlexApart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;
export const GRAY = '#dcdddf';